const sections = {
    stakingContract: (contract, timeRemaining) => ({
        className: "all-card",
        showEndDate: false,
        title: "90-DAY / 65%  ",
        // subTitle: "Accumulated Annual Percentage Rate ",
        subTitle: "Paid Via Smart Contract ",
        stakingContract: contract,
        timeRemaining: timeRemaining,
        disableStake: true,
        feePercent: 0.025,
        dailyReturn: 0.17,
        image: "stake-images/pink.png",
        info: {
            color: "#FA64DC",
            message:
                "Staking into this smart contract is no longer available for new deposits.\nHowever, users who have previously staked BTAF tokens can continue to interact with the contract as usual under the existing terms.",
        },
    }),

    stakingContract_35: (contract, timeRemaining) => ({
        className: "all-card all-card-35",
        showEndDate: false,
        title: "90-DAY / 35%  ",
        // subTitle: "Accumulated Annual Percentage Rate ",
        subTitle: "Paid Via Smart Contract ",
        stakingContract: contract,
        timeRemaining: timeRemaining,
        disableStake: true,
        feePercent: 0.025,
        dailyReturn: 0.095,
        image: "stake-images/purple.png",
        info: {
            color: "#CE87FD",
            message:
                "Staking into this smart contract is no longer available for new deposits.\nHowever, users who have previously staked BTAF tokens can continue to interact with the contract as usual under the existing terms.",
        },
    }),

    stakingContract_new: (contract, timeRemaining) => ({
        className: "all-card",
        showEndDate: false,
        title: "90-DAY / 35%  ",
        // subTitle: "Accumulated Annual Percentage Rate ",
        subTitle: "Paid Via Smart Contract ",
        stakingContract: contract,
        timeRemaining: timeRemaining,
        disableStake: true,
        feePercent: 0.025,
        dailyReturn: 0.095,
        image: "stake-images/green.png",
        info: {
            color: "#00B56E",
            message:
                "Staking into this smart contract is no longer available for new deposits.\nHowever, users who have previously staked BTAF tokens can continue to interact with the contract as usual under the existing terms.",
        },
    }),

    stakingContract_selfMaturing: (contract, timeRemaining) => ({
        className: "all-card all-card-35",
        showEndDate: true,
        title: "6 Months / 20%  ",
        // subTitle: "Accumulated Annual Percentage Rate ",
        subTitle: "Paid Via Smart Contract ",
        stakingContract: contract,
        timeRemaining: timeRemaining,
        disableStake: true,
        feePercent: 0.025,
        dailyReturn: 0.054,
        image: "stake-images/light-blue.png",
        maturesIn: 180,
        info: {
            color: "#00b2f8",
            message:
                "Staking into this smart contract is no longer available for new deposits.\nHowever, users who have previously staked BTAF tokens can continue to interact with the contract as usual under the existing terms.",
        },
    }),


    // New Staking Contract Sections by rajesh 
    stakingContractNewStake: (contract, timeRemaining) => ({
        className: "all-card",
        showEndDate: true,
        title: "6 Months / 2.5% ",
        subTitle: "Paid Via Smart Contract ",
        stakingContract: contract,
        timeRemaining: timeRemaining,
        disableStake: false,
        feePercent: 0.001,
        dailyReturn: 0.006849315,
        image: "stake-images/light-blue.png",
        maturesIn: 180,
        info: {
            color: "#00b2f8",
            message:
                "Staking into this contract is LIVE.\n You can interact with this contract as normal.\n Individual Smart Contract Escrow for Staking.",
        },
    }),

    stakingContractNewStakePrivate: (contract, timeRemaining) => ({
        className: "all-card",
        showEndDate: true,
        title: "6 Months / 3%  ",
        // subTitle: "Accumulated Annual Percentage Rate ",
        subTitle: "Paid Via Smart Contract ",
        stakingContract: contract,
        timeRemaining: timeRemaining,
        disableStake: false,
        feePercent: 0.001,
        dailyReturn: 0.008219178,
        image: "stake-images/light-blue.png",
        maturesIn: 180,
        info: {
            color: "#00f8b6ff",
            message:
                "Staking into this contract is LIVE.\n You can interact with this contract as normal.\n Individual Smart Contract Escrow for Staking.",
        },
    }),

    private_stake: (contract, timeRemaining) => ({
        className: "all-card all-card-35",
        showEndDate: true,
        title: "6 Months / 25%  ",
        // subTitle: "Accumulated Annual Percentage Rate ",
        subTitle: "Paid Via Smart Contract ",
        stakingContract: contract,
        timeRemaining: timeRemaining,
        disableStake: true,
        feePercent: 0.025,
        dailyReturn: 0.068,
        image: "stake-images/light-blue.png",
        maturesIn: 180,
        info: {
            color: "#00b2f8",
            message:
                "Staking into this smart contract is no longer available for new deposits.\nHowever, users who have previously staked BTAF tokens can continue to interact with the contract as usual under the existing terms.",
        },
    }),

    stakingContractAdditional: (contract, timeRemaining) => ({
        className: "all-card",
        showEndDate: true,
        title: "Additional Staking Contract",
        // subTitle: "Accumulated Annual Percentage Rate ",
        subTitle: "Paid Via Smart Contract ",
        stakingContract: contract,
        timeRemaining: timeRemaining,
        disableStake: false,
        feePercent: 0.025,
        dailyReturn: 0.054,
        image: "stake-images/light-blue.png",
        maturesIn: 180,
        info: {
            color: "#00b2f8",
            message:
                "Staking into this contract is LIVE.\n You can interact with this contract as normal.",
        },
    }),
};

const generateSections = (data = {}, OP = []) => {
    console.log("Generating sections with data:", data, "and OP:", OP);
    return OP.map(([contractName, timeRemainingName]) => {
        const [contract, timeRemaining] = [
            data[contractName],
            data[timeRemainingName],
        ];

        return sections[contractName](contract, timeRemaining);
    });
};

export default generateSections;
